import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";

// Admin pages
const AdminDashboard = lazy(() => import("@/pages/admin/AdminDashboard"));
const AdminUsers = lazy(() => import("@/pages/admin/AdminUsers"));
const OrganizationsList = lazy(() => import("@/pages/admin/OrganizationsList"));
const CreateOrganization = lazy(() => import("@/pages/admin/CreateOrganization"));
const OrganizationDetail = lazy(() => import("@/pages/admin/OrganizationDetail"));
const EditOrganization = lazy(() => import("@/pages/admin/EditOrganization"));
const RoleRequestsManager = lazy(() => import("@/pages/admin/RoleRequestsManager"));
const MembershipRequestsManager = lazy(() => import("@/pages/admin/MembershipRequestsManager"));
const TournamentsList = lazy(() => import("@/pages/admin/TournamentsList"));
const CreateTournament = lazy(() => import("@/pages/admin/CreateTournament"));
const TournamentDetail = lazy(() => import("@/pages/admin/TournamentDetail"));
const AdminTournamentsManager = lazy(() => import("@/pages/admin/AdminTournamentsManager"));
const ChatbotKnowledge = lazy(() => import("@/pages/admin/ChatbotKnowledge"));
const PendingDocuments = lazy(() => import("@/pages/admin/PendingDocuments"));
const TenUpClubsList = lazy(() => import("@/pages/admin/TenUpClubsList"));
const AdminPayments = lazy(() => import("@/pages/admin/AdminPayments"));
const AdminSubscriptions = lazy(() => import("@/pages/admin/AdminSubscriptions"));
const AdminFeedbacks = lazy(() => import("@/pages/admin/AdminFeedbacks"));
const AdminPayouts = lazy(() => import("@/pages/admin/AdminPayouts"));

/**
 * Admin-specific routes
 * All routes require super_admin role
 */
export const adminRoutes = (
  <>
    <Route
      path="/admin"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <AdminDashboard />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/users"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <AdminUsers />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/organizations"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <OrganizationsList />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/organizations/create"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <CreateOrganization />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/organizations/:id"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <OrganizationDetail />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/organizations/:id/edit"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <EditOrganization />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/role-requests"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <RoleRequestsManager />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/membership-requests"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <MembershipRequestsManager />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/tournaments"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <TournamentsList />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/tournaments/create"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <CreateTournament />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/tournaments/:id"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <TournamentDetail />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/tournaments-manager"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <AdminTournamentsManager />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/chatbot-knowledge"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <ChatbotKnowledge />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/pending-documents"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <PendingDocuments />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/tenup-clubs"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <TenUpClubsList />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/payments"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <AdminPayments />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/subscriptions"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <AdminSubscriptions />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/feedbacks"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <AdminFeedbacks />
        </ProtectedRoute>
      }
    />
    <Route
      path="/admin/payouts"
      element={
        <ProtectedRoute requiredRoles={["super_admin"]}>
          <AdminPayouts />
        </ProtectedRoute>
      }
    />
  </>
);
